export const getStyles = ({ companyIndex }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:py-3 tw:px-2 tw:flex tw:justify-center tw:bg-[#0756C0] tw:text-white tw:rounded-t-[12px]",
		contentWrapper:
			"tw:text-center tw:text-base tw:font-semibold tw:leading-6 tw:sm:text-lg",
	},
	serviceFlag: {
		wrapper: "tw:absolute tw:mt-0 tw:top-4 tw:flex tw:gap-0.5",
		flag: `tw:w-[28px] tw:h-[28px] tw:flex tw:items-center tw:justify-center ${companyIndex === 0 ? "tw:bg-[#0756C0]" : "tw:bg-[#E6E6E6]"}`,
		number: `tw:text-sm tw:font-medium tw:leading-6 ${companyIndex === 0 ? "tw:text-white " : "tw:text-[#212121]"}`,
		text: "tw:text-white tw:text-sm tw:bg-[#0756C0] tw:font-medium tw:leading-6 tw:flex tw:items-center tw:pl-2 tw:pt-0.5 tw:pr-4 tw:[clip-path:polygon(100%_0,calc(100%-10px)_100%,0_100%,0_0)]",
	},
	companyLogo: { picture: "", image: "" },
	rating: {
		wrapper:
			"tw:flex-row tw:lg:flex-col tw:w-fit tw:inline-flex tw:items-center tw:bg-[#FAFAFA] tw:px-0 tw:lg:px-6",
		score:
			"tw:mr-1 tw:lg:mr-0 tw:text-[36px] tw:lg:text-40 tw:font-semibold tw:leading-10 tw:tracking-[-1.6px] tw:text-[#212121]",
		stars:
			"tw:flex tw:flex-col tw:justify-evenly tw:items-start tw:pl-1 tw:lg:pl-0 tw:lg:items-center",
		starColor: "tw:text-[#1770d5]",
		starSize: "tw:text-base",
		count: "tw:pt-1 tw:text-xs tw:font-semibold tw:leading-4 tw:text-[#212121]",
	},
	benefitsList: {
		wrapper: "tw:mt-4",
		list: "tw:flex tw:flex-col tw:gap-2 tw:justify-center",
		listItem: "tw:flex tw:text-[#212121] tw:gap-2 tw:text-base tw:leading-6",
	},
	socialProof: {
		wrapper:
			"tw:relative tw:w-full tw:flex tw:justify-center tw:lg:max-w-fit tw:lg:bg-white tw:lg:rounded-lg tw:lg:p-2 tw:lg:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:lg:after:absolute tw:lg:after:right-[calc(50%-6px)] tw:lg:after:w-2.5 tw:lg:after:h-2.5 tw:lg:after:translate-x-0 tw:lg:after:-translate-y-2/4 tw:lg:after:rotate-45 tw:lg:after:bg-white tw:lg:after:overflow-hidden tw:lg:after:pointer-events-none tw:lg:after:bottom-[-10px]",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: "tw:text-[#0756C0] tw:text-xl tw:lg:text-[32px]",
		content:
			"tw:leading-4 tw:text-xs tw:text-left tw:text-[#212121] tw:lg:max-w-[110px] tw:lg:font-medium",
	},
	visitLink: {
		wrapper:
			"tw:inline-flex tw:w-full tw:group tw:justify-center tw:py-3 tw:px-2 tw:bg-[#0756C0] tw:rounded-[12px] tw:transition tw:duration-300 tw:gap-1.5 tw:cursor-pointer tw:hover:bg-[#0d4d9b]",
		contentWrapper:
			"tw:text-center tw:text-white tw:pt-0.5 tw:font-semibold tw:leading-6 tw:text-base tw:lg:pt-1.5 tw:lg:leading-4 tw:whitespace-nowrap",
		iconClass:
			"tw:text-2xl tw:text-white tw:transition-all tw:duration-300 tw:group-hover:translate-x-1 tw:inline-flex",
	},
});
